export default __webpack_public_path__ + "static/media/file-edit-alt.bcb9b787.svg";